import axios from 'axios';

const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    axios.defaults.headers.common[
      'x-yumyum-key'
    ] = `${process.env.REACT_APP_X_YUMYUM_KEY}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
    delete axios.defaults.headers.common['x-yumyum-key'];
  }
};

export default setAuthToken;
